<template>
  <MetricTest
    :metric-id="record.id"
    :configured-groupers="configuredGroupers"
    embedded
  />
</template>

<script>
import MetricTest from '@/components/Beta/MetricTest.vue';

export default {
  name: 'MetricReportSection',
  components: { MetricTest },
  props: {
    record: { type: Object, required: true },
    artifact: { type: Object, required: true },
    context: { type: Object, default: () => ({}) },
  },
  computed: {
    configuredGroupers() {
      return ((this.record.composable_config || {}).data_source_v2 || {}).group_by_columns || [];
    },
  },
};
</script>
